export const filterCheck: any = {
  "Model Type": true,
  "Risk Analysis": true
};

export const riskAnalysis: any = {
  "SAST": "SAST",
  "Fuzz Test": "Fuzz Test",
  "Unanalyzed": "Unanalyzed"
};

export const modelType: any = {
  "Classic": "Classic",
  "LLM": "LLM",
  "SLM": "SLM",
  "DL Model": "DL Model"
};
